import { components } from './components';
import { contracts } from './contracts';
import { packages } from './packages';
import { reschedule } from './reschedule';
import { schedule } from './schedule';
import { success } from './success';
import { unit } from './unit';

const pt = {
  ...components,
  ...contracts,
  ...packages,
  ...reschedule,
  ...schedule,
  ...success,
  ...unit,
};

export default pt;
